





















































































import Vue from 'vue'
import Tooltip from '@/components/atoms/Tooltip.vue'
import { Program } from 'vue/types/vue'

export default Vue.extend({
  name: 'SuggestedProgram',
  props: {
    program: Object as () => Program
  },
  components: {
    Tooltip
  },
  computed: {
  }
})
